(function () {
  if (window.kutufixSizeShowcaseLoaded) return;
  window.kutufixSizeShowcaseLoaded = true;
  function kur(kapsam) {
    (kapsam || document).querySelectorAll('.sx-vitrin').forEach(function (kutu) {
      if (kutu.dataset.vitrinReady === 'true') return;
      kutu.dataset.vitrinReady = 'true';
      kutu.querySelectorAll('.sihirbaz-input').forEach(function (girdi) {
        var oklar = kutu.querySelectorAll('[data-ok="' + girdi.dataset.dimension + '"]');
        girdi.addEventListener('focus', function () { oklar.forEach(function (o) { o.classList.add('aktif'); }); });
        girdi.addEventListener('blur', function () { oklar.forEach(function (o) { o.classList.remove('aktif'); }); });
      });
    });
  }
  document.addEventListener('shopify:section:load', function (e) { kur(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { kur(); }); else kur();
})();
